/**
 * CUSTOM USERCENTRICS CMP STYLES
 */
(function applyUCToggleStyles() {
  function injectStyles() {
    var ucBanner = document.getElementById('usercentrics-cmp-ui');
    if (ucBanner && ucBanner.shadowRoot) {
      if (!ucBanner.shadowRoot.querySelector('#custom-uc-switches-style')) {
        
        // Вземане на шрифта от body
        var siteFont = 'inherit';
        if (document.body) {
          var computedFont = window.getComputedStyle(document.body).fontFamily;
          if (computedFont) siteFont = computedFont;
        }

        var style = document.createElement('style');
        style.id = 'custom-uc-switches-style';
        style.textContent = `
          /* 1. Скриване на логото и линка "Powered by Usercentrics" */
          a[href*="usercentrics"],
          .uc-logo,
          .uc-footer,
          [aria-label*="Powered by Usercentrics"] {
            display: none !important;
            visibility: hidden !important;
            height: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
          }

          /* 2. Наследяване на шрифта и размер 16px */
          *,
          *::before,
          *::after,
          button,
          p,
          span,
          div,
          a,
          h1, h2, h3, h4 {
            font-family: ${siteFont} !important;
            font-size: 16px !important;
          }

          /* 3. Изключен / Заключен суич (disabled) */
          .uc-toggle-container button.uc-switch:disabled,
          button.uc-switch:disabled {
            background: #cccccc !important;
            opacity: 0.6 !important;
          }

          /* 4. Включен суич (active / checked) */
          .uc-toggle-container button.uc-switch[aria-checked="true"],
          button.uc-switch[aria-checked="true"] {
            background: #000000 !important;
          }
        `;
        ucBanner.shadowRoot.appendChild(style);
      }
    }
  }

  function startMonitoring() {
    injectStyles();
    setInterval(injectStyles, 100);
    
    if (document.documentElement) {
      var observer = new MutationObserver(injectStyles);
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // Изчакваме DOMContentLoaded или стартираме веднага
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startMonitoring);
  } else {
    startMonitoring();
  }
})();